module.exports = __webpack_public_path__ + "img/02.2ce1b5b8.png";